
const it = {
    quote: {
        title: 'Preventivi',
        recapHeader: 'Preventivo',
        mutateTitle: 'Preventivo',
        mutateSubtitle: 'Inserisci i dati del preventivo',
        list: 'Elenco Preventivi',
        reference: 'Riferimento',
        code: 'Codice',
        address: 'Indirizzo',
        registryName: 'Cliente',
        deliveryAddress: 'Indirizzo di consegna',
        quantity: 'Quantità',
        unitPrice: 'Prezzo Unitario',
        fixedPrice: 'Prezzo Una Tantum',
        discount: 'Sconto (%)',
        totalPrice: 'Prezzo Totale',
        dateRef: 'Data Preventivo',
        amountPreVat: 'Imponibile',
        vatAmount: 'IVA',
        totalWithVat: 'Totale con IVA',
        validUntil: 'Valido fino al',
        dateEndValidity: 'Data validità',
        transformToOrder: 'Trasforma in Ordine',
        viewRecap: 'Visualizza Riepilogo',
        deliveryDate: 'Data di consegna',
        quoteRecap: 'Riepilogo',
        document: 'Documento',
        seeOtherQuote: 'Vedi altri',
        step: {
            label: 'Fase',
            stepHeader: 'Dati Preventivo',
            stepDetail: 'Dettagli Preventivo',
            stepRecap: 'Riepilogo Preventivo'
        },
        docStatus: {
            label: 'Stato',
            DRAFT: 'Bozza',
            READY: 'Pronto',
            SENT: 'Inviato',
            RECEIVED: 'Preso in carico',
            INPROGRESS: 'In lavorazione',
            ONHOLD: 'In attesa',
            COMPLETED: 'Completato',
            CANCELED: 'Annullato',
            ALL: 'Tutti',
            NONE: 'Non definito'
        },
        discount1: 'Sconto',
        discount2: 'Sconto',
        discount3: 'Sconto',
        discountPercentage1: 'Sconto 1 (%)',
        discountPercentage2: 'Sconto 2 (%)',
        discountPercentage3: 'Sconto 3 (%)',
        remarks: 'Note',
        materialType: {
            label: 'Tipo di materiale',
            PVC: 'PVC',
            ALUMINIUM: 'Alluminio',
            WOOD: 'Legno'
        },
        tabName: {
            PVC: 'PVC',
            ALUMINIUM: 'Alluminio',
            WOOD: 'Legno',
            ALL: 'Preventivi'
        },
        transportLocation: 'Luogo di Consegna',
        transportType: {
            label: 'Tipo di trasporto',
            CLIENT: 'Presso sede Rivenditore',
            COMPANY: 'Presso sede Arcosistemi',
        },
        transportCost: 'Spese di Trasporto (€)',
        quoteType: {
            label: 'Tipo Documento',
            ORDER: 'Ordine',
            QUOTE: 'Preventivo',
            NONE: 'Non definito',
            ALL: 'Tutti'
        }


    },
    quoteVersion: {
        title: 'Versione',
        ver: 'Ver.',
        newVersion: 'Crea Versione'
    },
    quoteDetail: {
        title: 'Dettagli Preventivo',
        mutateSubtitle: 'Inserisci i dettagli del preventivo',
        addNewPosition: 'Aggiungi Posizione',
        hasWarning: 'Elemento da aggiornare - Controlla i dati e conferma',
        addItem: 'Aggiungi Voce',
        type: {
            label: 'Tipo',
            DOOR: 'Portafinestra',
            WINDOW: 'Finestra',
            NONE: 'Non definito'
        },
        side: {
            label: 'Lato apertura',
            LEFT: 'Sinistra',
            RIGHT: 'Destra',
            NONE: 'Non definito'
        },
        dimensionType: {
            label: 'Tipo Misure',
            MEASURE_HOLE: 'Misure Foro',
            MEASURE_SHUTTERS: 'Misure Scuro',
            NONE: 'Non definito'
        },
        handle: {
            label: 'Altezza Maniglia',
            F500: 'Fin. 500mm',
            PF1000: 'Portaf. 1000mm',
            OTHER: 'Altro',
            otherDescription: 'Descrizione',
            NONE: 'Non definito',
            HALF: 'Metà (solo per H < 1.000mm)',
            halfDescription: 'Metà ( {halfY}mm )',
            error: {
                handleRequired: 'Maniglia obbligatoria',
                handlePF1000AxisYTooSmall: 'Portaf. 1000mm non consentita per Altezza ≤ {min}',
                handleF500AxisYTooSmall: 'Fin. 500mm non consentita per Altezza < {min}',
                handleHalfInvalid: 'Metà non valida per Altezza = {y}'
            },

        },
        optionalType: {
            DOGA: '@:optional.optionalType.DOGA',
            CARDINI: '@:optional.optionalType.CARDINI',
            FERRAMENTA_SOSTEGNO_ESTERNA: '@:optional.optionalType.FERRAMENTA_SOSTEGNO_ESTERNA',
            //FERRAMENTA_SOSTEGNO_INTERNA: 'Ferramenta Sostegno Interna',
            FERMASCURI: '@:optional.optionalType.FERMASCURI',
            APPLICAZIONE: '@:optional.optionalType.APPLICAZIONE',
            BORDO: '@:optional.optionalType.BORDO',
            ALTEZZA_POSIZIONAMENTO: '@:optional.optionalType.ALTEZZA_POSIZIONAMENTO',
            TELAIO: '@:optional.optionalType.TELAIO',
            BATTUTA: '@:optional.optionalType.BATTUTA',
            PAREGGIATORE: '@:optional.optionalType.PAREGGIATORE',
            CHIUSURA_SUPERIORE: '@:optional.optionalType.CHIUSURA_SUPERIORE',
            CHIUSURA_INFERIORE: '@:optional.optionalType.CHIUSURA_INFERIORE',
            APERTURA: '@:optional.optionalType.APERTURA',
            CHIUSURA: '@:optional.optionalType.CHIUSURA',
            MURATURA: '@:optional.optionalType.MURATURA',
            CONTROTELAIO: '@:optional.optionalType.CONTROTELAIO',
            SPALLA: '@:optional.optionalType.SPALLA',
            SOLUZIONE_CHIUSURA_SERRATURA: '@:optional.optionalType.SOLUZIONE_CHIUSURA_SERRATURA',
            SEZIONE_MURO: '@:optional.optionalType.SEZIONE_MURO',

            SIDE4: '@:optional.optionalType.SIDE4',
            label: 'Tipo Dettaglio Opzionale'
        },
        count: 'Quantità',
        totalElements: 'Totale Elementi: {count}',
        position: 'Posizione',
        sasheCount: 'N. Ante',
        sashesWithCount: 'Ante: {count}',
        bandelleCount: 'N. Bandelle: {count}',
        bandelleNum: 'Bandelle Cad/Anta:',
        totalCount: 'Totale',
        totalCountHint: 'Inserisci il numero totale di elementi da consegnare',
        measure: {
            label: 'Misure',
            axisXMin: 'L.',
            axisYMin: 'H.',
            unit: 'mm'
        },
        axisX: 'Larghezza (mm)',
        axisY: 'Altezza (mm)',
        unitPrice: 'Prezzo Unitario (€)',
        remarks: 'Note',
        totalPrice: 'Prezzo Totale (€)',

        forcedPrice: 'Prezzo Forzato (€)',
        fixedPrice: 'Prezzo Una tantum (€)',
        measureShutterX: 'L. Usata~ {measure} mm',
        measureShutterY: 'H. Usata~ {measure} mm',
        transformToOrder: 'Duplica in Ordine',
        errors: {
            noEnabledOptionals: 'Nessun optional abilitato per il modello selezionato. Seleziona un altro modello o contatta l\'amministratore.',
            measuresNotValidated: 'Misure non validate',
            noPriceMeasureFoundForMeasuresAndOptionals: 'Nessun prezzo trovato per le misure e gli optional selezionati. Contattare l\'amministratore.',
            multiplePricesFoundForMeasuresAndOptionals: 'Sono stati trovati più prezzi per le misure e gli optional selezionati. Contattare l\'amministratore.',
        },
        price: {
            title: 'Prezzi Dettaglio Preventivo (* solo admin)',
            measurePrice: 'Prezzo Misura: ',
            measurePriceTotal: 'Prezzo Misura Totale: ',
            totalPrice: 'Prezzo Totale',
            forcedPrice: 'Prezzo Forzato',
            anteBandelleCount: 'N. Pezzi (Ante x Bandelle x Quantità): ',
            colorPrice: 'Prezzo Colore {percentage}',
            fixedDetailPrice: 'Prezzo Fisso',
            unitDetailPrice: 'Prezzo Unitario',
            percentageDetailPrice: 'Prezzo Percentuale {percentage} %',
            optionalPrice: 'Prezzo Opzionali',
            recalculatePrices: 'Ricalcola Prezzi',
            recalculateInfo: 'I prezzi verranno ricalcolati in base alle misure e agli optional selezionati.',
            optionalDetail: 'Dettagli',

        }
    },
    quoteOptional: {
        optionalValue: 'Valore',
        solution: {
            label: 'Soluzione',
            parA: 'Par. A',
            parB: 'Par. B',
            parC: 'Par. C',
            parS: 'Par. S',
            par0: 'Par. Ø',
            unit: 'mm'
        }
    },
    quoteAccessory: {
        title: 'Accessori Preventivo',
        mutateTitle: 'Accessorio Preventivo',
        mutateSubtitle: 'Inserisci i dati dell\'accessorio del preventivo',
        list: 'Elenco Accessori Preventivo',
        addItem: 'Aggiungi Accessorio',
        accessory: 'Accessorio di Posa',
        accessoryType: {
            label: 'Tipo Accessorio',
            POSA: 'Di Posa',
            OTHER: 'Altro',
            ALL: 'Tutti'
        },
        quantity: 'Quantità',
        quantityShort: 'Q.tà',
        unitPrice: 'Prezzo Unitario (€)',
        totalPrice: 'Prezzo Totale (€)',
        unitPriceShort: 'P.U. (€)',
        totalPriceShort: 'Tot. (€)',
        forcedPrice: 'Prezzo Forzato (€)',

        remarks: 'Note',
        errors: {
            accessoryRequired: 'Accessorio obbligatorio',
            quantityMin: 'Quantità minima 1',
            unitPriceMin: 'Prezzo unitario minimo 0'
        },
        addNewAccessory: 'Aggiungi Accessori di Posa'
    }

}
export default it
